import { config } from "../env";
import { Delete, get, patch, post } from "./helpers/http-handler";

export const getShowCauseNotices = (queryRequest: string) =>
  get(`${config.API_URL}/show-cause-notice?${queryRequest}`);

export const getSpecificShowCauseNotice = (id: string) =>
  get(`${config.API_URL}/show-cause-notice/fetch/${id}`);

export const createShowCauseNotice = (payload: object) =>
  post(`${config.API_URL}/show-cause-notice`, payload);

export const updateShowCauseNotice = (id: string, payload: object) =>
  patch(`${config.API_URL}/show-cause-notice/${id}`, payload);

export const deleteShowCauseNotice = (id: string) =>
  Delete(`${config.API_URL}/show-cause-notice/${id}`);

//details

export const getShowCauseNoticeDetails = (queryRequest: string) =>
  get(`${config.API_URL}/show-cause-notice/details?${queryRequest}`);

export const createShowCauseNoticeDetail = (payload: object) =>
  post(`${config.API_URL}/show-cause-notice/details`, payload);

//export 

export const exportShowCauseNotice = (queryRequest: string) =>
  get(`${config.API_URL}/show-cause-notice/export/data?${queryRequest}`);


export const getShowCauseNoticesEntityMapping = (queryRequest: string) =>
  get(`${config.API_URL}/show-cause-notice/entity-mapping?${queryRequest}`);

